import { CognitoUserPool, CognitoUserAttribute, AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import Cookies from 'js-cookie';
var CognitoAPI = /** @class */ (function () {
    function CognitoAPI(_a) {
        var userPoolId = _a.userPoolId, clientId = _a.clientId, orgId = _a.orgId;
        this.userPool = new CognitoUserPool({
            ClientId: clientId,
            UserPoolId: userPoolId,
        });
    }
    CognitoAPI.prototype.getUserData = function (session) {
        var email = '';
        try {
            email = session.idToken.payload.email;
        }
        catch (err) {
            console.error(err);
        }
        return {
            email: email,
            token: session.getIdToken().getJwtToken(),
        };
    };
    CognitoAPI.prototype.sessionLogin = function (ssoUrl) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var hash = window.location.hash.substr(1);
            var result = hash.split('&').reduce(function (result, item) {
                var parts = item.split('=');
                result[parts[0]] = parts[1];
                return result;
            }, {});
            // window.location.hash is used on SSO
            if (result['access_token']) {
                var timestampExpire = Date.now() + parseInt(result['expires_in']) * 1000;
                localStorage.setItem('sso_token_expire', timestampExpire.toString());
                return resolve({
                    email: '',
                    token: result['access_token'],
                });
            }
            // login using SSO token, if stored
            var ssoTokenExpire = localStorage.getItem('sso_token_expire');
            var token = localStorage.getItem('token');
            if (token) {
                if (ssoTokenExpire) {
                    if (parseInt(ssoTokenExpire) > Date.now()) {
                        return resolve({
                            email: '',
                            token: token,
                        });
                    }
                    localStorage.removeItem('token');
                    localStorage.removeItem('sso_token_expire');
                    Cookies.set('prevLocation', window.location.pathname, { expires: 0.1 });
                    return (window.location.href = ssoUrl);
                }
                else {
                    localStorage.removeItem('token');
                    localStorage.removeItem('sso_token_expire');
                }
            }
            // otherwise, use cognito sdk
            var cognitoUser = _this.userPool.getCurrentUser();
            if (!cognitoUser) {
                return reject({ message: 'no session' });
            }
            cognitoUser.getSession(function (err, session) {
                if (err) {
                    return reject(err);
                }
                if (!session.isValid()) {
                    return reject({ message: 'invalid session' });
                }
                cognitoUser.getUserAttributes(function (errAttr, attributes) {
                    if (errAttr) {
                        return reject(errAttr);
                    }
                    if (!attributes) {
                        return reject({ message: 'missing user data' });
                    }
                    return resolve(_this.getUserData(session));
                });
            });
        }).then(function (res) {
            localStorage.setItem('token', res.token);
            return res;
        });
    };
    CognitoAPI.prototype.signIn = function (email, password, newPassword) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var authenticationDetails = new AuthenticationDetails({
                Username: email,
                Password: password,
            });
            var cognitoUser = new CognitoUser({
                Username: email,
                Pool: _this.userPool,
            });
            var authCallbacks = {
                onSuccess: function (result) { return resolve(_this.getUserData(result)); },
                newPasswordRequired: function (userAttributes) {
                    // User was signed up by an admin and must provide new
                    // password and required attributes, if any, to complete
                    // authentication.
                    // the api doesn't accept this field back
                    delete userAttributes.email_verified;
                    if (!newPassword) {
                        return reject({
                            newPassword: true,
                            message: 'must create new password',
                        });
                    }
                    cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, authCallbacks);
                },
                onFailure: function (err) { return reject(err); },
            };
            cognitoUser.authenticateUser(authenticationDetails, authCallbacks);
        });
    };
    CognitoAPI.prototype.signUp = function (email, password, orgId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var dataEmail = {
                Name: 'email',
                Value: email,
            };
            var dataWebsite = {
                Name: 'website',
                Value: orgId,
            };
            var attributeEmail = new CognitoUserAttribute(dataEmail);
            var attributeWebsite = new CognitoUserAttribute(dataWebsite);
            var attributeList = [attributeEmail, attributeWebsite];
            var validationData = [];
            _this.userPool.signUp(email, password, attributeList, validationData, function (err, result) {
                if (err || !result) {
                    return reject(err);
                }
                if (result.userConfirmed === false) {
                    return resolve({
                        userConfirmed: result.userConfirmed,
                    });
                }
                return resolve(_this.getUserData(result));
            });
        });
    };
    CognitoAPI.prototype.confirmRegistration = function (email, password, code) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var userData = {
                Username: email,
                Pool: _this.userPool,
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.confirmRegistration(code, true, function (err, result) {
                if (err) {
                    reject(err);
                    return;
                }
                _this.signIn(email, password)
                    .then(resolve)
                    .catch(reject);
            });
        });
    };
    CognitoAPI.prototype.resendConfirmationCode = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var userData = {
                Username: email,
                Pool: _this.userPool,
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.resendConfirmationCode(function (err, result) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve({
                    userConfirmed: false,
                });
            });
        });
    };
    CognitoAPI.prototype.signOut = function () {
        var cognitoUser = this.userPool.getCurrentUser();
        if (!cognitoUser) {
            localStorage.removeItem('token');
            localStorage.removeItem('sso_token_expire');
            return null;
        }
        return cognitoUser.signOut();
    };
    CognitoAPI.prototype.forgotPassword = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var userData = {
                Username: email,
                Pool: _this.userPool,
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.forgotPassword({
                onSuccess: resolve,
                onFailure: reject,
            });
        });
    };
    CognitoAPI.prototype.confirmPassword = function (email, password, code) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var userData = {
                Username: email,
                Pool: _this.userPool,
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.confirmPassword(code, password, {
                onSuccess: function () {
                    return _this.signIn(email, password)
                        .then(resolve)
                        .catch(reject);
                },
                onFailure: reject,
            });
        });
    };
    return CognitoAPI;
}());
export { CognitoAPI };



//////////////////
// WEBPACK FOOTER
// ./src/auth/cognito/cognitoApi.ts
// module id = 1464
// module chunks = 81